<script lang="ts">
  export let text: string = "";

  // allowed tags
  const ALLOWED_TAGS: Record<string, string> = {
    "&lt;b&gt;": "<b>",
    "&lt;/b&gt;": "</b>",
    "&lt;strong&gt;": "<strong>",
    "&lt;/strong&gt;": "</strong>",
    "&lt;i&gt;": "<i>",
    "&lt;/i&gt;": "</i>",
    "&lt;em&gt;": "<em>",
    "&lt;/em&gt;": "</em>",
    "&lt;u&gt;": "<u>",
    "&lt;/u&gt;": "</u>"
  };

  // regex matching allowed html tags
  const TAG_REGEXP = new RegExp(Object.keys(ALLOWED_TAGS).join("|"), "gi");

  /**
   * Escapes all HTML to prevent XSS, then selectively restores
   * only whitelisted tags in a single pass.
   */
  function clean(text: string): string {
    if (!text) return "";
    return text
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(TAG_REGEXP, (match: string) => ALLOWED_TAGS[match.toLowerCase()]);
  }

  // handles string updates seamlessly
  $: safeHtml = clean(text);
</script>

{@html safeHtml}
